import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function Account() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user === false) navigate("/login");
    if (user) api.get("/orders").then((r) => setOrders(r.data)).catch(() => {});
  }, [user, navigate]);

  if (!user) return <div className="bg-ink min-h-screen pt-40 text-center font-mono text-graphite">Loading…</div>;

  return (
    <div className="bg-ink min-h-screen pt-32 pb-28" data-testid="account-page">
      <div className="container-sync">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="flex flex-wrap items-end justify-between gap-6 mb-16">
          <div>
            <p className="eyebrow mb-4">Your account</p>
            <h1 className="font-anton uppercase text-5xl sm:text-7xl leading-none">Hi, {user.name.split(" ")[0]}</h1>
            <p className="font-mono text-sm text-graphite mt-3">{user.email}</p>
          </div>
          <button onClick={() => { logout(); navigate("/"); }} data-testid="logout-btn" className="btn-outline">Sign Out</button>
        </motion.div>

        <h2 className="font-anton uppercase text-3xl mb-8">Order History</h2>
        {orders.length === 0 ? (
          <div className="border border-border p-10 text-center">
            <p className="text-graphite font-mono uppercase tracking-widest text-sm">No orders yet.</p>
            <Link to="/shop" className="btn-pulse mt-6">Start Shopping</Link>
          </div>
        ) : (
          <div className="space-y-4" data-testid="orders-list">
            {orders.map((o) => (
              <div key={o.session_id} className="border border-border p-6 flex flex-wrap justify-between gap-4">
                <div>
                  <p className="font-mono text-[11px] text-graphite uppercase tracking-wider">
                    {new Date(o.created_at).toLocaleDateString()} · #{o.session_id.slice(-8)}
                  </p>
                  <p className="mt-2 text-sm">{o.items?.map((i) => `${i.quantity}× ${i.name}`).join(", ")}</p>
                </div>
                <div className="text-right">
                  <span className="font-mono text-[11px] uppercase tracking-wider text-signal">Paid</span>
                  <p className="font-anton text-2xl">${o.amount?.toFixed(2)}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        {user.role === "admin" && (
          <div className="mt-16 border border-signal/40 p-6 flex flex-wrap items-center justify-between gap-4" data-testid="admin-dashboard-link-card">
            <div>
              <p className="eyebrow mb-1">Administrator</p>
              <p className="text-graphite text-sm">Orders, analytics, products, customers and inventory now live in the Admin Dashboard.</p>
            </div>
            <a href="/admin" className="btn-pulse" data-testid="open-admin-dashboard">Open Admin Dashboard</a>
          </div>
        )}
      </div>
    </div>
  );
}
